import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled", "onClick"]
const _hoisted_2 = {
  key: 0,
  class: "text-right o-text-caption mt-10"
}

import { computed } from 'vue';
import { PaymentOption, PaymentOptionType, PosPaymentOption } from '@/storecontext/shared/api/server-apis';
import { useCheckout } from '../../useCheckout';
import { sortBy } from 'lodash';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentOptions',
  props: {
    isClientValid: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { isClientValid: boolean }



const labels = useBlockLabels();
const { basket, initiatePayment, setShowBankTransferPaymentDialog, setSelectedPaymentOption, setIsPaymentReady } = useCheckout();

function clickPaymentOption(option: PaymentOption) {
    if (option.paymentOptionType === PaymentOptionType.BankTransfer) {
        setSelectedPaymentOption(option);
        setIsPaymentReady(true);
        setShowBankTransferPaymentDialog(true);
    } else {
        setSelectedPaymentOption(option);
        setIsPaymentReady(false);
        setShowBankTransferPaymentDialog(false);
        initiatePayment(option);
    }
}

const getIsPosOption = (option: PaymentOption) => {
    return option.paymentOptionType === PaymentOptionType.Pos;
};

const getIsBankTransferOption = (option: PaymentOption) => {
    return option.paymentOptionType === PaymentOptionType.BankTransfer;
};

const getIsPosV2Option = (option: PaymentOption) => {
    if (!getIsPosOption(option)) {
        return false;
    }

    const posOption = option as PosPaymentOption;

    return posOption.isPosV2Payment;
};

const options = computed<PaymentOption[]>(() => {
    return sortBy(basket.value.paymentOptions, (option) => getIsPosOption(option));
});

const hasDisabledOption = computed<boolean>(() => {
    return options.value.find(o => !o.enabled) !== undefined;
});

const isValidForPayment = computed<boolean>(() => {
    const invalidDeliverable = basket.value?.deliverables.find(deliverable => !deliverable.isValid);
    const serverInvalid = !!invalidDeliverable;
    const clientInvalid = !props.isClientValid;
    return !serverInvalid && !clientInvalid;
});


return (_ctx: any,_cache: any) => {
  const _component_CIcon = _resolveComponent("CIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex w-full", { 'opacity-50': !_unref(isValidForPayment) }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (option) => {
        return (_openBlock(), _createElementBlock("button", {
          key: option.discriminator,
          type: "button",
          class: _normalizeClass(["c-button md:ml-auto mr-x2 last:mr-0", {'c-button--primary flex flex-nowrap items-center': getIsPosOption(option), 'c-button--outline': !getIsPosOption(option)}]),
          disabled: !_unref(isValidForPayment) || !option.enabled,
          onClick: _withModifiers(($event: any) => (clickPaymentOption(option)), ["prevent"])
        }, [
          (getIsPosOption(option))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", null, _toDisplayString(getIsPosV2Option(option) ? _unref(labels).saveOrderToPosButton : _unref(labels).paymentSetPosTypeButton), 1),
                _createVNode(_component_CIcon, {
                  name: "icon-arrow-small",
                  class: "w-8 h-8 mt-1 ml-6 xl:h-10 xl:ml-8 xl:-mt-1"
                })
              ], 64))
            : (getIsBankTransferOption(option))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(labels).paymentBankTransferTypeButton), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_unref(labels).paymentGotoOnlineTypeButton), 1)
                ], 64))
        ], 10, _hoisted_1))
      }), 128))
    ], 2),
    (_unref(hasDisabledOption))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(labels).paymentGotoPosNotAvailableNote), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})